/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
  useState, useRef, useEffect, useMemo,
} from 'react';
import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'react-redux';
import {
  animated,
  useSpring,
  config as springConfig,
} from 'react-spring';
import IcomoonReact from 'icomoon-react';
import Shimmer from 'react-shimmer-effect';
import Text from '../../../../shared/components/Text/Text';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { setActiveModal, fetchSavedWorkoutDetail } from '../../ducks/calendarActions';

const WorkoutDetailsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: white;
  position: relative;
`;

const ContentWrapper = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ContentContainer = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.3s ease;
  pointer-events: ${(props) => (props.show ? 'auto' : 'none')};
`;

const ScrollableContent = styled('div')`
  flex: 1;
  position: relative;
  overflow-y: auto;
  padding: 0;
  min-height: 0;
  overflow-x: hidden;

  /* Hide the default scrollbar track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /* Style the scrollbar width */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  /* Style the scrollbar thumb */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  /* For Firefox */
  scrollbar-width: none;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
`;

const FixedHeader = styled('div')`
  margin-bottom: 2px;
`;

const FixedFooter = styled('div')`
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 1;
  margin-top: auto;
  margin-bottom: 40px;
`;

const DayContainer = styled('div')`
  margin-top: 24px;
  padding: 8px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(48, 49, 51, 0.3);
  width: 100%;
  max-width: ${(props) => props.maxWidth || 278}px;
  overflow: hidden;
  box-sizing: border-box;
  max-height: 330px;
  display: flex;
  flex-direction: column;
`;

const DayHeader = styled('div')`
  padding: 8px;
  border-bottom: 1px solid #EEEEEE;
  flex-shrink: 0;
`;

const DayContent = styled('div')`
  flex: 1;
  overflow-y: auto;
  padding: 8px;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

const WorkoutItemDiv = styled('div')`
  display: flex;
  cursor: pointer;
  width: 100%;
  position: relative;
  padding: 8px 0;
`;

const IconAndLine = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  position: relative;
`;

const VerticalLine = styled('div')`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  background: black;
  top: ${(props) => (props.isFirst ? '50%' : '-8px')};
  bottom: ${(props) => (props.isLast ? '50%' : '-8px')};
`;

const IconContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid black;
  background: white;
  position: relative;
  z-index: 1;
`;

const IconTitle = styled('div')`
  display: flex;
  align-items: center;
  flex: 1;
`;

const Title = styled('div')`
  font-size: 16px;
  font-family: 'Nunito Sans';
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NavigationHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  width: ${(props) => props.width || 280}px;
  padding: 0 16px;
  box-sizing: border-box;
  margin: 0 auto;
  box-shadow: 0px 1px 3px 0px rgba(48, 49, 51, 0.3);
`;

const WeekTitle = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NavigationButton = styled('div')`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: transparent;
  transition: all 250ms ease-in-out;
  
  &:hover {
    background-color: rgba(238, 238, 238, 0.6);
  }
  
  &:active {
    background-color: rgba(238, 238, 238, 0.9);
    transition: background-color 100ms ease-in-out;
  }
`;

const WeekContainer = styled('div')`
  width: ${(props) => props.width || 280}px;
  flex-shrink: 0;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 2px;
`;

const AnimationWrapper = styled('div')`
  display: flex;
  width: ${(props) => props.width || 280}px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
`;

const DayNumberText = styled(Text)`
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadProgramButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px;
  background: #444444;
  border: 2px solid #444444;
  color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
  margin-top: 16px;
`;

const WeekSelectorContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width || 280}px;
  padding: 0 16px;
  box-sizing: border-box;
  background: white;
  border-radius: 4px;
  margin: 0 auto;
`;

const WeekSelectorTitle = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 600;
  color: #444444;
  margin-bottom: 16px;
  text-align: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(238, 238, 238, 0.6);
  }
`;

const WeekNumbersContainer = styled('div')`
  display: flex;
  overflow-x: auto;
  gap: 8px;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

const WeekNumberBox = styled('div')`
  min-width: 76px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => (props.isSelected ? '#444444' : '#E0E0E0')};
  border-radius: 4px;
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: ${(props) => (props.isSelected ? '600' : '400')};
  color: ${(props) => (props.isSelected ? '#444444' : '#757575')};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #444444;
    color: #444444;
  }
`;

const WeekTitleButton = styled('div')`
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  user-select: none;
  
  &:hover {
    background-color: rgba(238, 238, 238, 0.6);
  }
`;

const WorkoutShimmerTitle = styled('div')`
  width: 200px;
  height: 24px;
  border-radius: 4px;
  background: #EEEEEE;
  margin-bottom: 16px;
  margin: 0 auto 16px auto;
`;

const WorkoutShimmerSubtitle = styled('div')`
  width: 150px;
  height: 20px;
  border-radius: 4px;
  background: #EEEEEE;
  margin-bottom: 8px;
  margin: 0 auto 8px auto;
`;

const WorkoutShimmerDay = styled('div')`
  margin-top: 24px;
  padding: 8px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(48, 49, 51, 0.3);
  width: 100%;
  max-width: ${(props) => props.maxWidth || 278}px;
  overflow: hidden;
  box-sizing: border-box;
  max-height: 330px;
  display: flex;
  flex-direction: column;
`;

const WorkoutShimmerDayHeader = styled('div')`
  padding: 8px;
  border-bottom: 1px solid #EEEEEE;
  flex-shrink: 0;
`;

const WorkoutShimmerDayTitle = styled('div')`
  width: 80px;
  height: 14px;
  border-radius: 4px;
  background: #EEEEEE;
  margin: 0 auto;
`;

const WorkoutShimmerDayContent = styled('div')`
  flex: 1;
  padding: 8px;
`;

const WorkoutShimmerExercise = styled('div')`
  display: flex;
  width: 100%;
  position: relative;
  padding: 8px 0;
`;

const WorkoutShimmerExerciseIcon = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #EEEEEE;
  background: #EEEEEE;
  margin-right: 10px;
  position: relative;
  z-index: 1;
`;

const WorkoutShimmerExerciseWrapper = styled('div')`
  display: flex;
  align-items: center;
  flex: 1;
`;

const WorkoutShimmerExerciseText = styled('div')`
  height: 16px;
  border-radius: 4px;
  background: #EEEEEE;
  flex: 1;
  max-width: 180px;
`;

const ShimmerWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.3s ease;
  pointer-events: ${(props) => (props.show ? 'auto' : 'none')};
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
`;

const ShimmerContentWrapper = styled('div')`
  width: ${(props) => props.width || 280}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
`;

const SavedWorkoutDetails = ({ workout, containerWidth = 280 }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const selectedSavedWorkout = useSelector((state) => state.calendar.data.selectedSavedWorkout);
  const isLoadingSavedWorkout = useSelector((state) => state.calendar.data.isLoadingSavedWorkout);
  const [showShimmer, setShowShimmer] = useState(true);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const shimmerTimer = useRef(null);

  const [currentWeekIndex, setCurrentWeekIndex] = useState(0);
  const [isResizing, setIsResizing] = useState(false);
  const resizeTimer = useRef(null);
  const animationWrapperRef = useRef(null);
  const [showWeekSelector, setShowWeekSelector] = useState(false);

  // Calculate dynamic week width based on container
  const weekWidth = useMemo(() => Math.max(250, containerWidth - 32), [containerWidth]);

  // Calculate dynamic day container width
  const dayContainerWidth = useMemo(() => Math.max(250, weekWidth - 32), [weekWidth]);

  useEffect(() => {
    // Reset to first week when workout changes
    setCurrentWeekIndex(0);
  }, [selectedSavedWorkout]);

  useEffect(() => {
    if (isLoadingSavedWorkout) {
      setShowShimmer(true);
      setShouldAnimate(false);
      clearTimeout(shimmerTimer.current);
    } else {
      shimmerTimer.current = setTimeout(() => {
        setShowShimmer(false);
        // Start animation after shimmer is hidden
        setShouldAnimate(true);
      }, 1000);
    }

    return () => {
      clearTimeout(shimmerTimer.current);
    };
  }, [isLoadingSavedWorkout]);

  // Track resize events
  useEffect(() => {
    const handleResize = () => {
      setIsResizing(true);
      clearTimeout(resizeTimer.current);

      resizeTimer.current = setTimeout(() => {
        setIsResizing(false);
      }, 200);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Reset animation when container width changes
  useEffect(() => {
    setIsResizing(true);
    clearTimeout(resizeTimer.current);

    resizeTimer.current = setTimeout(() => {
      setIsResizing(false);
      setShouldAnimate(true);
    }, 100);
  }, [weekWidth]);

  // Organize programItems by week - memoized to prevent recalculation on every render
  const { weeklyItems, totalWeeks } = useMemo(() => {
    if (!selectedSavedWorkout || !selectedSavedWorkout.programItems || !selectedSavedWorkout.programItems.length) {
      return { weeklyItems: [], totalWeeks: 0 };
    }

    // Create a deep copy of programItems to avoid mutating the original
    const programItems = JSON.parse(JSON.stringify(selectedSavedWorkout.programItems));

    // Find the maximum week number
    const weekNumbers = programItems.map((item) => item.weekNumber);
    const maxWeek = Math.max(...weekNumbers);

    // Create an array with length equal to the max week number
    const weekArray = Array.from({ length: maxWeek }, () => []);

    // Sort program items into weeks
    programItems.forEach((item) => {
      // Adjust for zero-based array indexing
      const weekIndex = item.weekNumber - 1;

      // Only push if within valid range
      if (weekIndex >= 0 && weekIndex < maxWeek) {
        weekArray[weekIndex].push(item);
      }
    });

    return {
      weeklyItems: weekArray,
      totalWeeks: weekArray.length,
    };
  }, [selectedSavedWorkout]);

  const goToPreviousWeek = () => {
    if (currentWeekIndex > 0) {
      setCurrentWeekIndex(currentWeekIndex - 1);
    }
  };

  const goToNextWeek = () => {
    if (currentWeekIndex < totalWeeks - 1) {
      setCurrentWeekIndex(currentWeekIndex + 1);
    }
  };

  // Animation for sliding weeks - responsive width translations
  const slideAnimation = useSpring({
    transform: `translateX(${-currentWeekIndex * weekWidth}px)`,
    width: `${totalWeeks * weekWidth}px`,
    display: 'flex',
    config: {
      ...springConfig.gentle,
      duration: 250,
    },
    immediate: isResizing || !shouldAnimate,
  });

  const handleLoadProgram = () => {
    // Fetch the full workout details first, then open the modal
    dispatch(fetchSavedWorkoutDetail(currentUser.accountCode, workout.info.id)).then(() => {
      dispatch(setActiveModal('loadProgramsModal'));
    });
  };

  const handleWeekTitleClick = () => {
    setShowWeekSelector(!showWeekSelector);
  };

  const handleWeekSelect = (weekIndex) => {
    setCurrentWeekIndex(weekIndex);
    setShowWeekSelector(false);
  };

  if (!selectedSavedWorkout && !isLoadingSavedWorkout) {
    return (
      <WorkoutDetailsContainer>
        <ContentWrapper>
          <ContentContainer show>
            <FixedHeader>
              <Text>Select a template to view details</Text>
            </FixedHeader>
          </ContentContainer>
        </ContentWrapper>
      </WorkoutDetailsContainer>
    );
  }

  return (
    <WorkoutDetailsContainer>
      <ShimmerWrapper show={showShimmer}>
        <ShimmerContentWrapper width={weekWidth}>
          <Shimmer>
            <WorkoutShimmerTitle />
          </Shimmer>
          <Shimmer>
            <WorkoutShimmerSubtitle />
          </Shimmer>
          {['day-1', 'day-2', 'day-3'].map((dayId) => (
            <WorkoutShimmerDay key={dayId} maxWidth={dayContainerWidth}>
              <WorkoutShimmerDayHeader>
                <Shimmer>
                  <WorkoutShimmerDayTitle />
                </Shimmer>
              </WorkoutShimmerDayHeader>
              <WorkoutShimmerDayContent>
                {['exercise-1', 'exercise-2', 'exercise-3', 'exercise-4', 'exercise-5'].map((exerciseId) => (
                  <WorkoutShimmerExercise key={`${dayId}-${exerciseId}`}>
                    <Shimmer>
                      <WorkoutShimmerExerciseIcon />
                    </Shimmer>
                    <WorkoutShimmerExerciseWrapper>
                      <Shimmer>
                        <WorkoutShimmerExerciseText />
                      </Shimmer>
                    </WorkoutShimmerExerciseWrapper>
                  </WorkoutShimmerExercise>
                ))}
              </WorkoutShimmerDayContent>
            </WorkoutShimmerDay>
          ))}
        </ShimmerContentWrapper>
      </ShimmerWrapper>

      <ContentContainer show={!showShimmer}>
        <FixedHeader>
          {selectedSavedWorkout?.description && (
            <Text style={{ marginTop: '8px' }}>{selectedSavedWorkout.description}</Text>
          )}

          {selectedSavedWorkout?.creator && (
            <Text style={{ marginTop: '8px' }}>
              Created by:
              {' '}
              {`${selectedSavedWorkout.creator.firstName || ''} ${selectedSavedWorkout.creator.lastName || ''}`}
            </Text>
          )}

          {selectedSavedWorkout?.programItems?.length > 0 && (
            <>
              {showWeekSelector ? (
                <WeekSelectorContainer width={weekWidth}>
                  <WeekSelectorTitle onClick={() => setShowWeekSelector(false)}>
                    Select Week
                  </WeekSelectorTitle>
                  <WeekNumbersContainer>
                    {Array.from({ length: totalWeeks }, (_, i) => (
                      <WeekNumberBox
                        key={`week-selector-${i + 1}`}
                        isSelected={currentWeekIndex === i}
                        onClick={() => handleWeekSelect(i)}
                      >
                        {i + 1}
                      </WeekNumberBox>
                    ))}
                  </WeekNumbersContainer>
                </WeekSelectorContainer>
              ) : (
                <NavigationHeader width={weekWidth}>
                  <NavigationButton onClick={goToPreviousWeek} disabled={currentWeekIndex === 0}>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={12}
                      icon='left-arrow'
                      color={currentWeekIndex === 0 ? '#DDDDDD' : '#9E9E9E'}
                    />
                  </NavigationButton>

                  <WeekTitleButton onClick={handleWeekTitleClick}>
                    <WeekTitle>
                      <Text fontWeight={600} fontSize='16px'>
                        Week
                        {' '}
                        {currentWeekIndex + 1}
                      </Text>
                    </WeekTitle>
                  </WeekTitleButton>

                  <NavigationButton onClick={goToNextWeek} disabled={currentWeekIndex === totalWeeks - 1}>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={12}
                      icon='right-arrow'
                      color={currentWeekIndex === totalWeeks - 1 ? '#DDDDDD' : '#9E9E9E'}
                    />
                  </NavigationButton>
                </NavigationHeader>
              )}
            </>
          )}
        </FixedHeader>

        <ScrollableContent>
          {selectedSavedWorkout?.programItems?.length > 0 && (
            <AnimationWrapper width={weekWidth} ref={animationWrapperRef}>
              <animated.div style={slideAnimation}>
                {weeklyItems.map((weekItems, weekIndex) => (
                  <WeekContainer width={weekWidth} key={`week-${weekIndex + 1}`}>
                    {weekItems.length === 0 ? (
                      <Text>No exercises for this week</Text>
                    ) : (
                      weekItems.map((dayItem) => (
                        <DayContainer maxWidth={dayContainerWidth} key={`day-${dayItem.dayNumber}`}>
                          <DayHeader>
                            <DayNumberText>
                              Day
                              {' '}
                              {dayItem.dayInWeek}
                            </DayNumberText>
                          </DayHeader>
                          <DayContent>
                            {dayItem.exercises ? dayItem.exercises.map((exercise, exerciseIndex) => {
                              const isFirst = exerciseIndex === 0;
                              const isLast = exerciseIndex === dayItem.exercises.length - 1;

                              return (
                                <WorkoutItemDiv key={`exercise-${exercise.assignedId || exercise.exerciseId}`}>
                                  <IconAndLine>
                                    <VerticalLine isFirst={isFirst} isLast={isLast} />
                                    <IconContainer>
                                      <IcomoonReact
                                        iconSet={iconSet}
                                        size={15}
                                        icon={exercise.icon}
                                        color='black'
                                      />
                                    </IconContainer>
                                  </IconAndLine>
                                  <IconTitle>
                                    <Title>{exercise.title}</Title>
                                  </IconTitle>
                                </WorkoutItemDiv>
                              );
                            }) : (
                              <Text style={{ display: 'flex', justifyContent: 'center' }} fontWeight={700}> Rest Day</Text>
                            )}
                          </DayContent>
                        </DayContainer>
                      ))
                    )}
                  </WeekContainer>
                ))}
              </animated.div>
            </AnimationWrapper>
          )}
        </ScrollableContent>

        <FixedFooter>
          <LoadProgramButton onClick={handleLoadProgram}>
            Load Program
          </LoadProgramButton>
        </FixedFooter>
      </ContentContainer>
    </WorkoutDetailsContainer>
  );
};

export default SavedWorkoutDetails;
